import { MouseEventHandler } from 'react';

import { css } from '@flipster/styled-system/css';
import { Button } from '@flipster/ui';

interface Props {
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const RatioButtons = ({ onClick }: Props) => {
  return (
    <div
      className={css({
        display: 'flex',
        gap: 4,
        my: 8,
        mb: 10,
        '& > *': {
          flex: 1,
          bg: 'legacy.gray.4!',
        },
      })}
    >
      {[10, 25, 50, 75, 100].map((ratio) => (
        <Button size='small' shape='primary' value={ratio} onClick={onClick} key={`from-amount-${ratio}`}>
          {ratio}%
        </Button>
      ))}
    </div>
  );
};
